// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-page hr {
  margin: 0;
}
.message-page .user-list {
  padding: 10px;
}
.message-page .message-row {
  margin-top: 10px;
}
.message-page .message-row .col-3 {
  text-align: center;
}
.message-page .message-row .col-3 img {
  max-width: 40px;
}
.message-page .message {
  padding: 10px;
  margin-top: 10px;
  border-radius: 10px;
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -pre-wrap; /* ancient Opera */
  white-space: -o-pre-wrap; /* newer Opera */
  white-space: pre-wrap; /* Chrome; W3C standard */
  word-wrap: break-word; /* IE */
}
.message-page .from-user .message {
  background: #4330ff;
  color: white;
}
.message-page .to-user .rounded-circle {
  margin-left: 10px;
}
.message-page .to-user .message {
  background: #eaeaea;
}
.message-page .message-form {
  background-color: #eaeaea;
  padding: 10px;
}
.message-page .message-submit-button {
  float: right;
  color: #4330ff;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
  padding: 3px 50px 3px 50px;
  display: inline-block;
}
.message-page .message-submit-button:hover {
  cursor: pointer;
  color: black;
}
.message-page .message-submit-button-disabled {
  color: gray;
}
.message-page .message-submit-button-disabled:hover {
  color: gray;
}
@media only screen and (max-width: 845px) {
  .message-page img {
    height: 55px;
    width: 55px;
  }
}
@media only screen and (max-width: 630px) {
  .message-page img {
    height: 38px;
    width: 38px;
  }
  .message-page .col-2 {
    margin-top: 10px;
    padding: 0;
  }
}

.list-messages {
  position: relative;
}
.list-messages .user-list {
  padding: 10px;
}
.list-messages .list-message-row {
  padding-top: 5px;
}
.list-messages .list-message-row .fa-angle-right {
  position: absolute;
  right: 0%;
  top: 40%;
  font-size: 2em;
  color: #c0c0c0;
}
.list-messages .list-message-row .timeframe {
  position: absolute;
  right: 0%;
  top: 80%;
  font-size: 1em;
  color: #c0c0c0;
}
.list-messages .list-message {
  color: black;
  padding: 10px 0 5px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
}

.list-messages:hover {
  background-color: #f2f2f2;
}

hr:hover {
  background-color: white;
}

.list-messages a:hover {
  text-decoration: none;
}

.list-messages[data-count]:after {
  position: absolute;
  right: 0%;
  top: 40%;
  font-size: 90%;
  content: attr(data-count);
  padding: 0.6em;
  border-radius: 999px;
  line-height: 0.75em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold;
}

.chars-left {
  font-size: 12px;
  color: #606060;
  margin: 5px 0 5px 10px;
}

`, "",{"version":3,"sources":["webpack://./src/components/Messages/messages.scss","webpack://./src/components/Messages/messages.css","webpack://./src/app/variables.scss"],"names":[],"mappings":"AAGC;EACC,SAAA;ACFF;ADIC;EACC,aAAA;ACFF;ADIC;EACC,gBAAA;ACFF;ADGE;EACC,kBAAA;ACDH;ADEG;EACC,eAAA;ACAJ;ADIC;EACC,aAAA;EACA,gBAAA;EACA,mBAAA;EACG,0BAAA,EAAA,YAAA;EACA,sBAAA,EAAA,kBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,yBAAA;EACA,qBAAA,EAAA,OAAA;ACFL;ADKE;EACC,mBEJW;EFKX,YAAA;ACHH;ADOE;EACC,iBAAA;ACLH;ADOE;EACC,mBE7BU;ADwBb;ADQC;EACC,yBEjCW;EFkCX,aAAA;ACNF;ADQC;EACG,YAAA;EACA,cEtBU;EFuBV,yBExCY;EFyCZ,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;ACNJ;ADOI;EACE,eAAA;EACA,YAAA;ACLN;ADQC;EACC,WAAA;ACNF;ADOE;EACI,WAAA;ACLN;ADQE;EACA;IACC,YAAA;IACA,WAAA;ECND;AACF;ADSC;EACC;IACC,YAAA;IACA,WAAA;ECPD;EDSA;IACC,gBAAA;IACA,UAAA;ECPD;AACF;;ADWA;EACE,kBAAA;ACRF;ADSC;EACC,aAAA;ACPF;ADSC;EACC,gBAAA;ACPF;ADQI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,cEnFQ;AD6Ed;ADQI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,cE1FQ;ADoFd;ADUC;EACC,YAAA;EACA,wBAAA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;ACRJ;;ADYA;EACC,yBE7Ge;ADoGhB;;ADYA;EACC,uBAAA;ACTD;;ADYA;EACC,qBAAA;ACTD;;ADYA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;ACTF;;ADYA;EACC,eExGS;EFyGT,cErIkB;EFsIlB,sBAAA;ACTD","sourcesContent":["@import '../../app/variables.scss';\n\n.message-page{\n\thr {\n\t\tmargin: 0;\n\t}\n\t.user-list {\n\t\tpadding: 10px;\n\t}\n\t.message-row{\n\t\tmargin-top: 10px;\n\t\t.col-3 {\n\t\t\ttext-align: center;\n\t\t\timg {\n\t\t\t\tmax-width: 40px;\n\t\t\t}\n\t\t}\n\t}\n\t.message{\n\t\tpadding: 10px;\n\t\tmargin-top: 10px;\n\t\tborder-radius: 10px;\n\t    white-space: -moz-pre-wrap; /* Firefox */\n\t    white-space: -pre-wrap; /* ancient Opera */\n\t    white-space: -o-pre-wrap; /* newer Opera */\n\t    white-space: pre-wrap; /* Chrome; W3C standard */\n\t    word-wrap: break-word; /* IE */\n\t}\n\t.from-user {\n\t\t.message{\n\t\t\tbackground: $evanta-blue;\n\t\t\tcolor: white;\n\t\t}\n\t}\n\t.to-user{\n\t\t.rounded-circle{\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\t.message{\n\t\t\tbackground: $light-gray;\n\t\t}\n\t}\n\t.message-form {\n\t\tbackground-color: $light-gray;\n\t\tpadding: 10px;\n\t}\n\t.message-submit-button {\n    float: right;\n    color: $evanta-blue;\n    background-color: $lightest-gray;\n    border: 1px solid $medium-gray;\n    border-radius: 5px;\n    padding: 3px 50px 3px 50px;\n    display: inline-block;\n    &:hover {\n      cursor: pointer;\n      color: black;\n    }\n  }\n\t.message-submit-button-disabled{\n\t\tcolor: gray;\n\t\t&:hover {\n      color: gray;\n    }\n\t}\n  @media only screen and (max-width : 845px){\n\t\timg {\n\t\t\theight: 55px;\n\t\t\twidth: 55px;\n\t\t}\n\t}\n\n\t@media only screen and (max-width : 630px){\n\t\timg {\n\t\t\theight: 38px;\n\t\t\twidth: 38px;\n\t\t}\n\t\t.col-2 {\n\t\t\tmargin-top: 10px;\n\t\t\tpadding:0;\n\t\t}\n\t}\n}\n\n.list-messages {\n  position: relative;\n\t.user-list {\n\t\tpadding: 10px;\n\t}\n\t.list-message-row {\n\t\tpadding-top: 5px;\n    .fa-angle-right {\n      position: absolute;\n      right: 0%;\n      top: 40%;\n      font-size: 2em;\n      color: $medium-gray;\n    }\n    .timeframe {\n      position: absolute;\n      right: 0%;\n      top: 80%;\n      font-size: 1em;\n      color: $medium-gray;\n    }\n\n\t}\n\t.list-message {\n\t\tcolor: black;\n\t\tpadding: 10px 0 5px 10px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 80%;\n\t}\n}\n\n.list-messages:hover{\n\tbackground-color: $lightest-gray;\n}\n\nhr:hover {\n\tbackground-color: white;\n}\n\n.list-messages a:hover {\n\ttext-decoration: none;\n}\n\n.list-messages[data-count]:after{\n  position: absolute;\n  right: 0%;\n  top: 40%;\n  font-size: 90%;\n  content: attr(data-count);\n  padding: .6em;\n  border-radius: 999px;\n  line-height: .75em;\n  color: white;\n  background: rgba(255,0,0,.85);\n  text-align: center;\n  min-width: 2em;\n  font-weight: bold;\n}\n\n.chars-left {\n\tfont-size: $smaller;\n\tcolor: $medium-dark-gray;\n\tmargin: 5px 0 5px 10px;\n}\n",".message-page hr {\n  margin: 0;\n}\n.message-page .user-list {\n  padding: 10px;\n}\n.message-page .message-row {\n  margin-top: 10px;\n}\n.message-page .message-row .col-3 {\n  text-align: center;\n}\n.message-page .message-row .col-3 img {\n  max-width: 40px;\n}\n.message-page .message {\n  padding: 10px;\n  margin-top: 10px;\n  border-radius: 10px;\n  white-space: -moz-pre-wrap; /* Firefox */\n  white-space: -pre-wrap; /* ancient Opera */\n  white-space: -o-pre-wrap; /* newer Opera */\n  white-space: pre-wrap; /* Chrome; W3C standard */\n  word-wrap: break-word; /* IE */\n}\n.message-page .from-user .message {\n  background: #4330ff;\n  color: white;\n}\n.message-page .to-user .rounded-circle {\n  margin-left: 10px;\n}\n.message-page .to-user .message {\n  background: #eaeaea;\n}\n.message-page .message-form {\n  background-color: #eaeaea;\n  padding: 10px;\n}\n.message-page .message-submit-button {\n  float: right;\n  color: #4330ff;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  border-radius: 5px;\n  padding: 3px 50px 3px 50px;\n  display: inline-block;\n}\n.message-page .message-submit-button:hover {\n  cursor: pointer;\n  color: black;\n}\n.message-page .message-submit-button-disabled {\n  color: gray;\n}\n.message-page .message-submit-button-disabled:hover {\n  color: gray;\n}\n@media only screen and (max-width: 845px) {\n  .message-page img {\n    height: 55px;\n    width: 55px;\n  }\n}\n@media only screen and (max-width: 630px) {\n  .message-page img {\n    height: 38px;\n    width: 38px;\n  }\n  .message-page .col-2 {\n    margin-top: 10px;\n    padding: 0;\n  }\n}\n\n.list-messages {\n  position: relative;\n}\n.list-messages .user-list {\n  padding: 10px;\n}\n.list-messages .list-message-row {\n  padding-top: 5px;\n}\n.list-messages .list-message-row .fa-angle-right {\n  position: absolute;\n  right: 0%;\n  top: 40%;\n  font-size: 2em;\n  color: #c0c0c0;\n}\n.list-messages .list-message-row .timeframe {\n  position: absolute;\n  right: 0%;\n  top: 80%;\n  font-size: 1em;\n  color: #c0c0c0;\n}\n.list-messages .list-message {\n  color: black;\n  padding: 10px 0 5px 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 80%;\n}\n\n.list-messages:hover {\n  background-color: #f2f2f2;\n}\n\nhr:hover {\n  background-color: white;\n}\n\n.list-messages a:hover {\n  text-decoration: none;\n}\n\n.list-messages[data-count]:after {\n  position: absolute;\n  right: 0%;\n  top: 40%;\n  font-size: 90%;\n  content: attr(data-count);\n  padding: 0.6em;\n  border-radius: 999px;\n  line-height: 0.75em;\n  color: white;\n  background: rgba(255, 0, 0, 0.85);\n  text-align: center;\n  min-width: 2em;\n  font-weight: bold;\n}\n\n.chars-left {\n  font-size: 12px;\n  color: #606060;\n  margin: 5px 0 5px 10px;\n}\n\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
